export const GP_API_DEV_URL = 'https://globalpayroll-api-dev-fe.xemplo.team';
export const EIMS_DEV_URL = 'https://id-dev.xemplo.team';

//Maximum number value to send BE in number fields
export const MAX_NUMBER_VALUE = 99999999999999;

export const FUTURE_SCHEDULED_PAYRUN = '00000000-0000-0000-0000-000000000000';

export const FILE_SIZE_LIMIT = 20 * 1024 * 1024;
